<script setup>
import { useForm } from '@inertiajs/vue3'
import AuthLayout from '@/Layouts/AuthLayout.vue'
import UiButton from '@/Components/UI/UiButton.vue'

const props = defineProps({
  reset_password_token: { type: String, required: true },
  errors: { type: Object, default: () => ({}) },
})

const form = useForm({
  password: '',
  password_confirmation: '',
  reset_password_token: props.reset_password_token,
})

function submit() {
  form.transform((data) => ({ user: data })).patch('/users/password')
}
</script>

<template>
  <AuthLayout title="Set a new password">
    <form @submit.prevent="submit" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-[color:var(--inkSoft)] mb-1">New password</label>
        <input
          v-model="form.password"
          type="password"
          required
          minlength="8"
          class="w-full border rounded-[var(--radius-md)] bg-[color:var(--surface)] text-[color:var(--ink)] px-3 py-2 text-sm focus:outline-2 focus:outline-[color:var(--accent)]"
          :class="form.errors.password ? 'border-[color:var(--danger)]' : 'border-[color:var(--line)]'"
        />
        <p v-if="form.errors.password" class="mt-1 text-xs text-[color:var(--danger)]">{{ form.errors.password }}</p>
      </div>

      <div>
        <label class="block text-sm font-medium text-[color:var(--inkSoft)] mb-1">Confirm password</label>
        <input
          v-model="form.password_confirmation"
          type="password"
          required
          class="w-full border rounded-[var(--radius-md)] bg-[color:var(--surface)] text-[color:var(--ink)] px-3 py-2 text-sm focus:outline-2 focus:outline-[color:var(--accent)]"
          :class="form.errors.password_confirmation ? 'border-[color:var(--danger)]' : 'border-[color:var(--line)]'"
        />
        <p v-if="form.errors.password_confirmation" class="mt-1 text-xs text-[color:var(--danger)]">
          {{ form.errors.password_confirmation }}
        </p>
      </div>

      <UiButton
        type="submit"
        variant="primary"
        :loading="form.processing"
        class="w-full justify-center"
      >
        {{ form.processing ? 'Saving…' : 'Set new password' }}
      </UiButton>
    </form>
  </AuthLayout>
</template>
